import {
  OrganizationAdminMenu,
  OrganizationUserMenu,
} from './OrganizationMenu';
import { SuperAdminItems } from './SuperAdminMenu';
import { UserMenu } from './UserMenu';

import { useSelector } from 'third-party';

import { appSelectors } from 'selectors';

import { APIOrganization } from 'types/api';
import { MenuType } from 'types/app';

export const useMenu = () => {
  const isSuperAdmin = useSelector(appSelectors.isSuperAdmin);
  const selectedOrganization = useSelector(appSelectors.selectedOrganization);

  if (selectedOrganization) {
    const groups: MenuType[] = [
      ...OrganizationUserMenu(
        selectedOrganization.organization as APIOrganization,
      ),
      ...OrganizationAdminMenu(
        selectedOrganization.organization as APIOrganization,
      ),
    ];
    if (isSuperAdmin) {
      groups.push({
        items: SuperAdminItems(selectedOrganization.organization.id),
      });
    }
    return groups;
  }

  const groups = UserMenu();
  if (isSuperAdmin) {
    groups[groups.length - 1].items.push(...SuperAdminItems());
  }
  return groups;
};
